const verticalSpacing = (space) => {
	switch (space) {
		case "none":
			return "";

		case "small":
			return "py-2 md:py-2";

		case "medium":
			return "py-4 md:py-8";

		case "large":
			return "py-8 md:py-16";

		default:
			return null;
	}
};

export default verticalSpacing;